function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import * as Sentry from "@sentry/nextjs";
import { trackEvent } from "/services/bigbrain-service";
import { HUBSPOT_FORM_SUBMIT_FAILED, HUBSPOT_FORM_SUBMIT_SUCCESS, QUALIFIED_CHATBOT_EVENT, QUALIFIED_CHATBOT_LISTENER_FAILED } from "constants/bigbrain-event-types";
import { setCookie } from "services/cookies-service";
import { CONTACT_SALES_FORM_DATA } from "constants/cookies";
import { SERVER_STORAGE_KEYS } from "constants/contact-flow";
import { sendHubspotForm } from "client/services/hubspot-service/hubspot-service";
import { PORTAL_ID, CONTACT_SALES_HUBSPOT_FORM_ID } from "client/services/hubspot-service/contact-form-config";
import { HUBSPOT_API_EMAIL, HUBSPOT_API_FIRSTNAME, HUBSPOT_API_LASTNAME, HUBSPOT_API_PHONE, HUBSPOT_API_COMPANY, HUBSPOT_API_COMPANY_SIZE, HUBSPOT_API_PRODUCT_QUESTION, HUBSPOT_API_HOW_CAN_HELP, HUBSPOT_API_SOURCE, HUBSPOT_API_FROM, HUBSPOT_API_PRIVACY_CONSENT, HUBSPOT_API_RECENT_CONVERSION_URL, HUBSPOT_API_ELIGIBLE_FOR_BOOK_A_MEETING } from "client/services/hubspot-service/hubspot-constants";
const QUALIFIED_GOAL_ACHIEVED = "sales_meeting_goal_achieved";
const QUALIFIED_SALES_MEETING_GOAL_DISQUALIFIED_USER_EXISTS = "sales_meeting_goal_disqualified_user_exists";
const QUALIFIED_SALES_MEETING_GOAL_DISQUALIFIED_COMPANY_SIZE = "sales_meeting_goal_disqualified_company_size";
const QUALIFIED_SALES_MEETING_GOAL_DISQUALIFIED_COUNTRY = "sales_meeting_goal_disqualified_country";
/**
 * Splits a full name string into first and last name (first word vs rest).
 * @param {string} fullName
 * @returns {{ firstname: string, lastname: string }}
 */ export const parseFullNameToFirstAndLast = (fullName)=>{
    if (!fullName || typeof fullName !== "string") {
        return {
            firstname: "",
            lastname: ""
        };
    }
    const parts = fullName.trim().split(/\s+/);
    var _parts_, _parts_slice_join;
    return {
        firstname: (_parts_ = parts[0]) !== null && _parts_ !== void 0 ? _parts_ : "",
        lastname: (_parts_slice_join = parts.slice(1).join(" ")) !== null && _parts_slice_join !== void 0 ? _parts_slice_join : ""
    };
};
export const submitQualifiedLeadToHubspot = function() {
    var _ref = _async_to_generator(function*(qualifiedEventData) {
        var _window_location;
        const values = qualifiedEventData === null || qualifiedEventData === void 0 ? void 0 : qualifiedEventData.field_values;
        if (!values || typeof values !== "object") {
            return;
        }
        const email = values.email;
        if (!email) {
            return;
        }
        var _values_first_name;
        let firstname = (_values_first_name = values.first_name) !== null && _values_first_name !== void 0 ? _values_first_name : "";
        var _values_last_name;
        let lastname = (_values_last_name = values.last_name) !== null && _values_last_name !== void 0 ? _values_last_name : "";
        if ((!firstname || !lastname) && values.name) {
            const parsed = parseFullNameToFirstAndLast(values.name);
            if (!firstname) {
                firstname = parsed.firstname;
            }
            if (!lastname) {
                lastname = parsed.lastname;
            }
        }
        var _values_phone_number, _ref;
        const phone = (_ref = (_values_phone_number = values.phone_number) !== null && _values_phone_number !== void 0 ? _values_phone_number : values.phone) !== null && _ref !== void 0 ? _ref : "";
        var _values_company;
        const company = (_values_company = values.company) !== null && _values_company !== void 0 ? _values_company : "";
        var _values_company_size;
        const companySize = (_values_company_size = values.company_size) !== null && _values_company_size !== void 0 ? _values_company_size : "";
        var _values_how_do_you_plan_to_use_mondaycom;
        const howPlanToUse = (_values_how_do_you_plan_to_use_mondaycom = values.how_do_you_plan_to_use_mondaycom) !== null && _values_how_do_you_plan_to_use_mondaycom !== void 0 ? _values_how_do_you_plan_to_use_mondaycom : "";
        var _values_cs_main_product, _ref1;
        const csMainProduct = (_ref1 = (_values_cs_main_product = values.cs_main_product) !== null && _values_cs_main_product !== void 0 ? _values_cs_main_product : values.main_product) !== null && _ref1 !== void 0 ? _ref1 : "";
        var _window_location_href;
        const fields = [
            {
                name: HUBSPOT_API_EMAIL,
                value: String(email)
            },
            {
                name: HUBSPOT_API_FIRSTNAME,
                value: String(firstname)
            },
            {
                name: HUBSPOT_API_LASTNAME,
                value: String(lastname)
            },
            {
                name: HUBSPOT_API_PHONE,
                value: String(phone)
            },
            {
                name: HUBSPOT_API_COMPANY,
                value: String(company)
            },
            {
                name: HUBSPOT_API_COMPANY_SIZE,
                value: String(companySize)
            },
            {
                name: HUBSPOT_API_HOW_CAN_HELP,
                value: String(howPlanToUse)
            },
            {
                name: HUBSPOT_API_PRODUCT_QUESTION,
                value: String(csMainProduct)
            },
            {
                name: HUBSPOT_API_SOURCE,
                value: "Website - Contact Sales"
            },
            {
                name: HUBSPOT_API_FROM,
                value: "Qualified"
            },
            {
                name: HUBSPOT_API_PRIVACY_CONSENT,
                value: true
            },
            {
                name: HUBSPOT_API_RECENT_CONVERSION_URL,
                value: typeof window !== "undefined" ? (_window_location_href = (_window_location = window.location) === null || _window_location === void 0 ? void 0 : _window_location.href) !== null && _window_location_href !== void 0 ? _window_location_href : "" : ""
            },
            {
                name: HUBSPOT_API_ELIGIBLE_FOR_BOOK_A_MEETING,
                value: true
            }
        ];
        try {
            yield sendHubspotForm(PORTAL_ID, CONTACT_SALES_HUBSPOT_FORM_ID, fields, false);
            trackEvent(HUBSPOT_FORM_SUBMIT_SUCCESS);
        } catch (err) {
            trackEvent(HUBSPOT_FORM_SUBMIT_FAILED);
            Sentry.captureException(err);
            Sentry.captureMessage("Qualified lead HubSpot submit failed:", err);
        }
    });
    return function submitQualifiedLeadToHubspot(qualifiedEventData) {
        return _ref.apply(this, arguments);
    };
}();
const buildAdaContactSalesContext = (qualifiedEventData)=>{
    const values = qualifiedEventData === null || qualifiedEventData === void 0 ? void 0 : qualifiedEventData.field_values;
    if (!values || typeof values !== "object") {
        return null;
    }
    var _values_first_name;
    let firstname = (_values_first_name = values.first_name) !== null && _values_first_name !== void 0 ? _values_first_name : "";
    var _values_last_name;
    let lastname = (_values_last_name = values.last_name) !== null && _values_last_name !== void 0 ? _values_last_name : "";
    if ((!firstname || !lastname) && values.name) {
        const parsed = parseFullNameToFirstAndLast(values.name);
        if (!firstname) {
            firstname = parsed.firstname;
        }
        if (!lastname) {
            lastname = parsed.lastname;
        }
    }
    var _values_email, _values_phone_number, _ref, _values_company, _values_company_size, _values_cs_main_product, _ref1, _values_how_do_you_plan_to_use_mondaycom;
    const formData = {
        [SERVER_STORAGE_KEYS.CONTACT_SALES_FIRST_NAME]: String(firstname !== null && firstname !== void 0 ? firstname : ""),
        [SERVER_STORAGE_KEYS.CONTACT_SALES_LAST_NAME]: String(lastname !== null && lastname !== void 0 ? lastname : ""),
        [SERVER_STORAGE_KEYS.CONTACT_SALES_EMAIL]: String((_values_email = values.email) !== null && _values_email !== void 0 ? _values_email : ""),
        [SERVER_STORAGE_KEYS.CONTACT_SALES_PHONE]: String((_ref = (_values_phone_number = values.phone_number) !== null && _values_phone_number !== void 0 ? _values_phone_number : values.phone) !== null && _ref !== void 0 ? _ref : ""),
        [SERVER_STORAGE_KEYS.CONTACT_SALES_COMPANY]: String((_values_company = values.company) !== null && _values_company !== void 0 ? _values_company : ""),
        [SERVER_STORAGE_KEYS.CONTACT_SALES_COMPANY_SIZE]: String((_values_company_size = values.company_size) !== null && _values_company_size !== void 0 ? _values_company_size : ""),
        [SERVER_STORAGE_KEYS.CONTACT_SALES_PRODUCT_QUESTION]: String((_ref1 = (_values_cs_main_product = values.cs_main_product) !== null && _values_cs_main_product !== void 0 ? _values_cs_main_product : values.main_product) !== null && _ref1 !== void 0 ? _ref1 : ""),
        [SERVER_STORAGE_KEYS.CONTACT_SALES_OPEN_TEXT]: String((_values_how_do_you_plan_to_use_mondaycom = values.how_do_you_plan_to_use_mondaycom) !== null && _values_how_do_you_plan_to_use_mondaycom !== void 0 ? _values_how_do_you_plan_to_use_mondaycom : "")
    };
    return formData;
};
const passQualifiedContextToAda = (qualifiedEventData)=>{
    const adaContext = buildAdaContactSalesContext(qualifiedEventData);
    if (adaContext) {
        const jsonString = JSON.stringify(adaContext);
        setCookie(CONTACT_SALES_FORM_DATA, encodeURIComponent(jsonString));
    }
};
/**
 * Handler for Qualified handleEvents callback. Tracks the event and submits to HubSpot on Goal Achieved / Disqualified.
 */ const handleQualifiedEvent = (name, data)=>{
    trackEvent(QUALIFIED_CHATBOT_EVENT, {
        kind: name,
        data: {
            chatbot_data: JSON.stringify(data || {})
        }
    });
    if (name === QUALIFIED_GOAL_ACHIEVED || name === QUALIFIED_SALES_MEETING_GOAL_DISQUALIFIED_USER_EXISTS || name === QUALIFIED_SALES_MEETING_GOAL_DISQUALIFIED_COMPANY_SIZE || name === QUALIFIED_SALES_MEETING_GOAL_DISQUALIFIED_COUNTRY) {
        submitQualifiedLeadToHubspot(data);
        if (name === QUALIFIED_SALES_MEETING_GOAL_DISQUALIFIED_COMPANY_SIZE) {
            passQualifiedContextToAda(data);
        }
    }
};
/**
 * Registers the Qualified chatbot event handler. Call when Qualified is enabled.
 * Tracks QUALIFIED_CHATBOT_LISTENER_FAILED if window.qualified is not available.
 */ export const registerQualifiedChatbot = ()=>{
    if (window.qualified) {
        window.qualified("handleEvents", handleQualifiedEvent);
    } else {
        trackEvent(QUALIFIED_CHATBOT_LISTENER_FAILED);
    }
};
